import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import { IFilters } from "@/interfaces/Fetch";
import {
  useDeleteCompanyNoteMutation,
  useGetCompanyNotesQuery,
} from "@/services/companies/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { FC, useEffect, useState } from "react";
import { ToastContentProps, toast } from "react-toastify";
import NotesCard from "../NotesCard";

const CompanyNotesCard: FC<
  PaginateCardProps & {
    id: string;
    showOrHiddenNoteModal: (
      companyId: string,
      noteId: string,
      message: string
    ) => void;
  }
> = ({ id: companyId, onGetTotal, showOrHiddenNoteModal }) => {
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isError, error } = useGetCompanyNotesQuery([
    companyId,
    filters,
  ]);
  const [deleteCompanyNoteAsync] = useDeleteCompanyNoteMutation();

  const showNoteModal = (noteId: string, message: string) => {
    showOrHiddenNoteModal(companyId, noteId, message);
  };

  const onDeleteNote = (id: string) => {
    toast.promise(deleteCompanyNoteAsync([companyId, id]).unwrap(), {
      pending: "Suppresion de la note en cours...",
      success: {
        render() {
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              La note à bien été supprimée 🤩
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "Les champs que vous avez remplis semblent être incorrects.";
          }

          return "Une erreur est survenue";
        },
      },
    });
  };

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader />;
  } else if (isError) {
    return <ErrorComponent error={error} returnButton />;
  }

  return (
    <NotesCard
      data={data?.data}
      meta={data?.meta}
      filters={filters}
      setFilters={setFilters}
      onRemove={onDeleteNote}
      onEdit={showNoteModal}
    />
  );
};

export default CompanyNotesCard;
